// extracted by mini-css-extract-plugin
export default {"main":"NoMatchPage_main__lEt3c","text":"NoMatchPage_text__H-gh5","link":"NoMatchPage_link__GPc8A"};